const WIDTH_SP = 768;
const WIDTH_PC = 1280;

(() => {

  // 初期化処理
  const init = () => {
    const body = document.querySelector('body');
    body.classList.remove('preload');

    // 各初期化関数の呼び出し
    initIsOn();
    initFadeInElements();
    initSliders();
    initFormBtnClick();
  };

  // リサイズ
  const handleResize = () => {
    // 各初期化関数の呼び出し
    
  };

  // スクロール
  let lastScrollTime = 0;
  const handleScroll = () => {
    const now = Date.now();
    if (now - lastScrollTime >= 100) {
      initFadeInElements();
      initIsOn();
      lastScrollTime = now;
    }
  };

  // イベントリスナーの登録
  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', handleResize);
  document.addEventListener('scroll', handleScroll);
  
})();


// スクロールでis-onクラスを付与
const initIsOn = () => {
  document.querySelectorAll('.js-scroll').forEach(elem => {
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;

    const isLoad = elem.dataset.load !== undefined;
    const dispPosition = offset - windowHeight;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add('is-show');
    }
  });
};

// 要素のフェード
const initFadeInElements = () => {
  document.querySelectorAll('.js-fade-in').forEach(elem => {
    const rect = elem.getBoundingClientRect().top;
    const scroll = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect + scroll;
    const windowHeight = window.innerHeight;
    const delay = parseFloat(elem.dataset.delay) || 0;
    const isLoad = elem.dataset.load !== undefined;
    const positionPc = parseFloat(elem.dataset.positionPc) || 200;
    const positionSp = parseFloat(elem.dataset.positionSp) || 0;
    const position = document.body.clientWidth > WIDTH_SP ? positionPc : positionSp;
    const dispPosition = offset - windowHeight + position;
    const duration = parseFloat(elem.dataset.duration) || 1.5;

    if (scroll > dispPosition || isLoad) {
      elem.classList.add('js-scroll-in');
      elem.style.transitionDelay = `${delay}s`;
      elem.style.transitionDuration = `${duration}s`;
    }
  });
};

// Swiper初期化
const initSliders = () => {

  const mySwiper = new Swiper('.business-voice-slide', {
    loop: true,
    slidesPerView: 1.3,
    spaceBetween: "2%",
    speed: 300,
    centeredSlides: true,

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },

    // Navigation arrows
    navigation: {
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next',
    },

    // レスポンシブ
    breakpoints: {
      769: {
        slidesPerView: 2.2,
      }
    }
  });
  
  // CSSアニメーションで流れるようにする
  const introSlider = document.querySelector('.business-intro-slider');
  if (introSlider) {
    const wrapper = introSlider.querySelector('.business-intro-slider__wrapper');
    if (wrapper) {
      // スライドを複製して無限ループを作る
      const slides = wrapper.querySelectorAll('.business-intro-slider__item');
      slides.forEach(slide => {
        const clone = slide.cloneNode(true);
        wrapper.appendChild(clone);
      });
      
      // CSSアニメーション用のクラスを追加
      wrapper.classList.add('is-scrolling');
    }
  }
};

// ビジネスボタンクリック時の処理
const initFormBtnClick = () => {
  const formBtns = document.querySelectorAll('.form-show');
  const businessContactForm = document.querySelector('.contact-form-section');
  
  if (formBtns.length > 0 && businessContactForm) {
    formBtns.forEach((formBtn) => {
      formBtn.addEventListener('click', (e) => {
        if (window.innerWidth >= WIDTH_PC) {
          // デフォルトのスクロール動作を防ぐ
          e.preventDefault();
          
          // 現在のスクロール位置を保持
          const currentScrollY = window.scrollY;
          
          businessContactForm.classList.add('show');
          
          const globoFormApp = businessContactForm.querySelector('.globo-form-app');
          if (globoFormApp) {
            // .close要素が存在しない場合のみ作成
            if (!globoFormApp.querySelector('.close')) {
              const closeElement = document.createElement('p');
              closeElement.className = 'close';
              closeElement.textContent = '戻る';
              globoFormApp.appendChild(closeElement);
            }
          }
          
          // スクロール位置を元に戻す（showクラス追加によるスクロールを防ぐ）
          // requestAnimationFrameで確実にスクロール位置を保持
          requestAnimationFrame(() => {
            window.scrollTo(0, currentScrollY);
          });
        }
      });
    });
  }
  
  // closeアイコンクリック
  if (businessContactForm) {
    businessContactForm.addEventListener('click', (e) => {
      // .close要素をクリックした場合
      if (e.target.classList.contains('close')) {
        if (window.innerWidth >= WIDTH_PC && businessContactForm.classList.contains('show')) {
          businessContactForm.classList.remove('show');
          // .close要素を削除
          const globoFormApp = businessContactForm.querySelector('.globo-form-app');
          if (globoFormApp) {
            const closeElement = globoFormApp.querySelector('.close');
            if (closeElement) {
              closeElement.remove();
            }
          }
        }
      }
    });
  }
};